export { default } from "./dashed-border";
